// Copied from legacy CV https://github.com/tkww/xo-guest-services/blob/master/client/wws/src/utilities/analytics/index.js#L3
export default () => {
  const route = window.location.pathname.split('/')[2];

  return {
    category: 'bride facing',
    name: route ? route.replace(/-/g, ' ') : null,
    audienceType: 'bride',
    resolution: `${window.innerWidth}x${window.innerHeight}`,
    cookieSize: document.cookie.length,
  };
};
